<template>
    <div>
        <v-card class="mb-6 pa-3 pa-md-6 visit-info-card">
            <v-card-title class="pa-0 mb-3">신청인 정보</v-card-title>
            <validation-provider rules="required" v-slot="{ errors }" name="성함">
                <v-text-field
                    v-model="innerInfo.agentName"
                    counter="20"
                    maxlength="20"
                    label="성명 *"
                    :error-messages="errors[0]"
                />
            </validation-provider>

            <validation-provider rules="required|mobile" v-slot="{ errors }" name="휴대폰">
                <v-text-field
                    v-model="innerInfo.agentMobile"
                    label="휴대폰 *"
                    @keyup="changeMobile(innerInfo.agentMobile)"
                    @focus="changeMobile(innerInfo.agentMobile)"
                    maxlength="13"
                    :error-messages="errors[0]"
                >
                </v-text-field>

            </validation-provider>

            <validation-provider rules="required" v-slot="{ errors }" name="소속 업체명">
                <v-text-field
                    v-model="innerInfo.agentCompany"
                    label="소속 업체명 *"
                    counter="25"
                    maxlength="25"
                    :error-messages="errors[0]"
                />
            </validation-provider>
        </v-card>
    </div>
</template>

<script>
import utilService from "@/service/utilService";
import {extend, ValidationProvider} from 'vee-validate';
import {required} from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: '{_field_}을 입력해주세요.',
})

extend('mobile', {
    validate(v) {
        const re = /(01[016789])[-]?(\d{3,4})[-]?(\d{4})$/g;
        return re.test(v);
    },
    message: '정확한 휴대폰 번호를 입력하세요'
})


export default {
    name: 'ApplyStep1',

    props: {
        value: Object
    },

    components: {
        ValidationProvider,
    },

    data: () => ({
        isLoading: false,
        innerInfo: {
            agentName: null,
            agentMobile: null,
            agentCompany: null,
        }
    }),

    computed: {

    },

    watch: {
        innerInfo: {
            async handler(v) {
                this.$emit('input', v);
            },
            deep: true
        }
    },

    created() {
        this.innerInfo = this.value;
    },

    methods: {
        changeMobile(str) {
            this.innerInfo.agentMobile = utilService.humanReadableMobile(str);
        },
    }
}
</script>